import { FIND_LOG } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function findLog(props: IFindUserInformation) {
  var thisUrl = FIND_LOG + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  //   const populateFields =
  //     "blocks financial schoolDriverInformation companyInformation driverInformation.city driverInformation.province driverInformation.plateNumber driverInformation.financialGroup gender driverInformation.subscriptionExpireAt driverInformation.nationalCode driverInformation.driverLicenseNumber driverInformation.insuranceNumber driverInformation.address driverInformation.uniqueCodeThirdPartyInsurance driverInformation.approved driverInformation.carBrand driverInformation.carModel driverInformation.carColor driverInformation.carSystem driverInformation.insuranceExpiryDate driverInformation.vin avatar";

  //   thisUrl += `&populate=${populateFields}`;

  //   let schoolDriverInformation;
  //   if (props.companyId) {
  //     schoolDriverInformation = {
  //       "schoolDriverInformation.company": props.companyId,
  //     };
  //   }

  let body: any = {};

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  // if (props?.search?.value) {
  //   body = {
  //     query: {
  //       ...body.query,
  //       [String(props.search.base)]: utils.convertNumbers2English(
  //         props.search.value
  //       ),
  //     },
  //   };
  // }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const {
      startDate,
      endDate,
      superAgent,
      school,
      student,
      parent,
      driver,
      company,
    } = props.filters;

    body = {
      ...body,
      startDate: startDate,
      endDate: endDate,
      superAgent: superAgent?._id,
      school: school?._id,
      student: student?._id,
      parent: parent?._id,
      driver: driver?._id,
      company: company?._id,
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findLog;
